import React, { createContext, useContext } from 'react';
import { useGetMeQuery, GetMeQuery } from 'graphql/types';
import Loading from 'modules/loading/Loading';
import { useTriggerMlTraining } from 'modules/App/hooks/useTriggerMlTraining';
import Theme from '../../Theme';
import { useSentryUserContext } from './useMeSentryContext';

export const MeContext = createContext<GetMeQuery['me']>(null);

export const useMeContext = (): GetMeQuery['me'] => useContext(MeContext);

const MeContextProvider: React.FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const { loading, data } = useGetMeQuery({ fetchPolicy: 'cache-first' });

  useSentryUserContext(data);
  useTriggerMlTraining();

  if (loading) {
    return (
      <Theme direction={'ltr'}>
        <Loading />
      </Theme>
    );
  }

  return <MeContext.Provider value={data?.me}>{children}</MeContext.Provider>;
};

export default MeContextProvider;
